var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from '@emotion/styled';
import { Card } from 'rebass';
import { maxWidth, border, compose, } from 'styled-system';
import { Text } from '../';
var _Card = styled(Card)(compose(border, maxWidth));
var Pill = React.forwardRef(function (_a, ref) {
    var as = _a.as, fontSize = _a.fontSize, fontWeight = _a.fontWeight, children = _a.children, color = _a.color, tooltipContent = _a.tooltipContent, onClick = _a.onClick, props = __rest(_a, ["as", "fontSize", "fontWeight", "children", "color", "tooltipContent", "onClick"]);
    return (React.createElement(_Card, __assign({ sx: {
            display: 'inline-block',
            borderRadius: '100px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            cursor: onClick ? 'pointer' : undefined,
        }, onClick: onClick }, props, { ref: ref }),
        React.createElement(Text, { as: as, color: color, fontWeight: fontWeight, fontSize: fontSize }, children)));
});
Pill.defaultProps = {
    px: 3,
    py: 2,
    mr: 2,
    fontSize: '12px',
    fontWeight: 'bold',
};
export default React.memo(Pill);
